import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common'; 
import { MatFormFieldModule } from '@angular/material/form-field'; 
import { MatInputModule } from '@angular/material/input'; 
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox'; // ➔ 1. importを追加

import { Addresses, AddressesFormComponent, AddressesDefaultValue } from '../../addresses-form/addresses-form.component';
import { PAYMENT_METHOD } from 'src/app/constants/app-constants';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-billing-source-form',
  templateUrl: './billing-source-form.component.html',
  imports: [
    AddressesFormComponent,

    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
  ],
})
export class BillingSourceFormComponent implements OnInit{
  @Input() billingSourceForm!: FormGroup;
  private readonly destroyRef = inject(DestroyRef);

  readonly paymentMethods = PAYMENT_METHOD;

  ngOnInit(): void {
    // this.setChangeEvents();
  }

  get invoiceAddressesGroup(): FormGroup {
    return this.billingSourceForm.get('invoiceInfo.addresses') as FormGroup;
  }
  
  onPaymentMethodChange(selectedMethod: string): void {
    console.log("onPaymentMethodChanged", selectedMethod);
    const invoiceInfo_useMainAddress = this.billingSourceForm.get('invoiceInfo.useMainAddress');
    const creditCardInfo = this.billingSourceForm.get('creditCardInfo');
    const directDebitInfo = this.billingSourceForm.get('directDebitInfo');

    // 一旦すべて無効（Disabled）にする
    invoiceInfo_useMainAddress?.disable();
    creditCardInfo?.disable();
    directDebitInfo?.disable();

    // 選択されたフォームグループだけを有効化（Enabled）にする
    switch (selectedMethod) {
      case 'Invoice':
        invoiceInfo_useMainAddress?.enable;
        this.onUseMainAddressChange(invoiceInfo_useMainAddress?.value);
        break;
      case 'CreditCard':
        creditCardInfo?.enable();
        break;
      case 'DirectDebit':
        directDebitInfo?.enable();
        break;
    }
  }

  onUseMainAddressChange(checked: boolean){
    console.log("onUseMainAddressChange", checked);

    const invoiceInfo = this.billingSourceForm.get('invoiceInfo');

    invoiceInfo?.disable({ emitEvent: false });
    invoiceInfo?.get('useMainAddress')?.enable({ emitEvent: false }); // { emitEvent: false } を指定しないとこの変更によって onUseMainAddressChange()が再度呼び出されて無限ループになる
    invoiceInfo?.get('billToPersonName')?.enable({ emitEvent: false });
    invoiceInfo?.get('billToEmailAddresses')?.enable({ emitEvent: false });

    // 「メインアドレスを使用する」にチェックが入っていないときだけ住所関連の項目も入力可にする
    if (!checked){
      invoiceInfo?.get('addresses')?.enable({ emitEvent: false });
    }
  }

  
  static createBillingSourceGroup(): FormGroup {
    return new FormGroup({
      paymentMethod: new FormControl("Invoice", [Validators.required]),
      invoiceInfo: new FormGroup({
        useMainAddress: new FormControl(true),
        addresses: AddressesFormComponent.createAddressesGroup(),
        billToPersonName: new FormControl(""),
        billToEmailAddresses: new FormControl(""),
      }),
      creditCardInfo: new FormGroup({
        creditCardToken: new FormControl("")
      }),
      directDebitInfo: new FormGroup({
        last4: new FormControl(""),
        bankName: new FormControl(""),
        branchName: new FormControl(""),
        accountType: new FormControl(""),
        accountHolderName: new FormControl(""),
        accountNumber: new FormControl("")
      })
    });
  }
}


export interface InvoiceInfo {
  useMainAddress: boolean;
  addresses: Addresses;
  billToPersonName: string;
  billToEmailAddresses: string;
}
export const InvoiceInfoDefaultValue = {
    useMainAddress: true,
    addresses : AddressesDefaultValue,
    billToPersonName: "",
    billToEmailAddresses: "",
}

export interface CreditCardInfo {
  creditCardToken?: string | null;
}
export const CreditCardInfoDefaultValue = {
    creditCardToken: "",
}

export interface DirectDebitInfo {
  last4?: string | null;
  bankName?: string | null;
  branchName?: string | null;
  accountType?: string | null;
  accountHolderName?: string | null;
  accountNumber?: string | null;
}
export const DirectDebitInfoDefaultValue = {
    last4: "",
    bankName: "",
    branchName: "",
    accountType: "",
    accountHolderName: "",
    accountNumber: "",
}

export interface BillingSource {
  /** 支払い方法。1: 請求書払い、2: クレジットカード払い、3: 銀行口座払いなど */
  paymentMethod: string; 
  invoiceInfo?: InvoiceInfo;
  creditCardInfo?: CreditCardInfo; // paymentMethod が CreditCard のときに指定する。Stripeのカードトークン
  directDebitInfo?: DirectDebitInfo; // paymentMethod が BankAccount のときに指定する。銀行口座情報
}
export const BillingSourceDefaultValue = {
    paymentMethod: PAYMENT_METHOD[0].code,
    invoiceInfo: InvoiceInfoDefaultValue,
    creditCardInfo: CreditCardInfoDefaultValue,
    directDebitInfo: DirectDebitInfoDefaultValue,
}
